//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Builder.js";
import "../no/SelectNXObject.js";
import "../no/SelectObject.js";
let d=[[[0,"HcpAJfingerRadio",1,0],[0,"HcpAJjointDrpdwn",1,0],[0,"HcpAJjointSldr1",1,0],[0,"HcpAJjointSldr2",1,0],[0,"HcpAJjointSldr3",1,0],[0,"HcpAJjointSldr4",1,0],[0,"HcpAJjointSldr5",1,0],[0,"HcpAJrangeMax1",1,0],[0,"HcpAJrangeMax2",1,0],[0,"HcpAJrangeMax3",1,0],[0,"HcpAJrangeMax4",1,0],[0,"HcpAJrangeMax5",1,0],[0,"HcpAJrangeMin1",1,0],[0,"HcpAJrangeMin2",1,0],[0,"HcpAJrangeMin3",1,0],[0,"HcpAJrangeMin4",1,0],[0,"HcpAJrangeMin5",1,0],[0,"HcpAJsideRadio",1,0],[0,"HcpAJsymmetryCheck",1,0],[1,"HcpHumanSelector",0,"SelectNXObject",0],[0,"HcpMANbodyPartDrpdwn",1,0],[0,"HcpMANjointSldr1",1,0],[0,"HcpMANjointSldr2",1,0],[0,"HcpMANjointSldr3",1,0],[0,"HcpMANlockCheck",1,0],[0,"HcpMANmirrorCheck",1,0],[0,"HcpMANpostTypeRadio",1,0],[0,"HcpMANreachCsys",1,"CoordinateSystem",0],[0,"HcpMANsideRadio",1,0],[0,"HcpPLapertureSldr",1,0],[0,"HcpPLpostFileNameEnt",1,0],[0,"HcpPLpostLibDrpdwn",1,0],[0,"HcpPLpostNameEnt",1,0],[0,"HcpPLpostureTypeRadio",1,0],[0,"HcpPLsideRadio",1,0]],[[[],"HcpPLstandardBtn1",{},0,0],[[],"HcpPLstandardBtn2",{},0,0],[[],"HcpPLstandardBtn3",{},0,0],[[],"HcpPLpostLibAddBtn",{},0,0],[[],"HcpPLpostLibOpenBtn",{},0,0],[[],"HcpPLpostLibDelBtn",{},0,0],[[],"HcpPLdelPostBtn",{},0,0],[[],"HcpPLaddPostBtn",{},0,0],[[],"HcpPLapplyBtn",{},0,0],[[],"HcpPLopenPostFileBtn",{},0,0],[["humanfeaturebuilder"],"SetHumanFeatureBuilder",{},1,0]],[]];
SPLM.HumanHCPDialogBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.HumanHCPDialogBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.HumanHCPDialogBuilder.PostureType = Object.freeze({
    "Standing" : "Standing", "Seated" : "Seated"});

SPLM.HumanHCPDialogBuilder.ManipBodyPartType = Object.freeze({
    "Vision" : "Vision", "Torso" : "Torso", "Pelvis" : "Pelvis", "Elbow" : "Elbow", "Hand" : "Hand", "Knee" : "Knee", "Foot" : "Foot"});

SPLM.HumanHCPDialogBuilder.ManipSideType = Object.freeze({
    "Left" : "Left", "Right" : "Right"});

SPLM.HumanHCPDialogBuilder.JointType = Object.freeze({
    "Head" : "Head", "Torso" : "Torso", "Shoulder" : "Shoulder", "Elbow" : "Elbow", "Wrist" : "Wrist", "Hand" : "Hand", "Hip" : "Hip", "Knee" : "Knee", "Foot" : "Foot"});

SPLM.HumanHCPDialogBuilder.JointSideType = Object.freeze({
    "Left" : "Left", "Right" : "Right"});

SPLM.HumanHCPDialogBuilder.FingerType = Object.freeze({
    "Thumb" : "Thumb", "Index" : "Index", "Middle" : "Middle", "Ring" : "Ring", "Little" : "Little"});

SPLM.HumanHCPDialogBuilder.PostureLibraryType = Object.freeze({
    "FullBody" : "FullBody", "Hand" : "Hand"});

SPLM.HumanHCPDialogBuilder.HandSideType = Object.freeze({
    "Left" : "Left", "Right" : "Right", "Both" : "Both"});

SPLM.HumanHCPDialogBuilder.PostureLibrarySelType = Object.freeze({
    "Default" : "Default"});

export default SPLM;